import { Trans, useTranslation } from "react-i18next";
import PolicyPage, { PolicySection } from "../../components/policy/PolicyPage";

function PoliticaDatos() {
    const { t } = useTranslation();

    return (
        <PolicyPage title={t("policyDatos.title")}>
            <PolicySection title={t("policyDatos.sec1.title")}>
                <p><Trans i18nKey="policyDatos.sec1.p1" components={{ strong: <strong /> }} /></p>
                <p>{t("policyDatos.sec1.p2")}</p>
                <ul>
                    <li>{t("policyDatos.sec1.email")}: <a href="mailto:emmpieza@gmail.com">emmpieza@gmail.com</a></li>
                    <li>{t("policyDatos.sec1.whatsapp")}: <a href="https://wa.me/573118569675">+57 311 856 9675</a></li>
                </ul>
            </PolicySection>

            <PolicySection title={t("policyDatos.sec2.title")}>
                <p>{t("policyDatos.sec2.intro")}</p>
                <ul>
                    {t("policyDatos.sec2.items", { returnObjects: true }).map((item, i) => (
                        <li key={i}><strong>{item.strong}</strong> {item.text}</li>
                    ))}
                </ul>
            </PolicySection>

            <PolicySection title={t("policyDatos.sec3.title")}>
                <p>{t("policyDatos.sec3.intro")}</p>
                <ul>
                    {t("policyDatos.sec3.items", { returnObjects: true }).map((item, i) => (
                        <li key={i}>{item}</li>
                    ))}
                </ul>
            </PolicySection>

            <PolicySection title={t("policyDatos.sec4.title")}>
                <p>{t("policyDatos.sec4.intro")}</p>
                <ul>
                    {t("policyDatos.sec4.items", { returnObjects: true }).map((item, i) => (
                        <li key={i}><strong>{item.strong}</strong> {item.text}</li>
                    ))}
                </ul>
            </PolicySection>

            <PolicySection title={t("policyDatos.sec5.title")}>
                <p>{t("policyDatos.sec5.intro")}</p>
                <ul>
                    {t("policyDatos.sec5.items", { returnObjects: true }).map((item, i) => (
                        <li key={i}>{item}</li>
                    ))}
                </ul>
            </PolicySection>

            <PolicySection title={t("policyDatos.sec6.title")}>
                <p>{t("policyDatos.sec6.body")}</p>
            </PolicySection>

            <PolicySection title={t("policyDatos.sec7.title")}>
                <p>{t("policyDatos.sec7.intro")}</p>
                <ul>
                    {t("policyDatos.sec7.items", { returnObjects: true }).map((item, i) => (
                        <li key={i}><strong>{item.strong}</strong> {item.text}</li>
                    ))}
                </ul>
                <p>
                    {t("policyDatos.sec7.outro")}{" "}
                    <a href="mailto:emmpieza@gmail.com">emmpieza@gmail.com</a>
                </p>
            </PolicySection>

            <PolicySection title={t("policyDatos.sec8.title")}>
                <p>{t("policyDatos.sec8.intro")}</p>
                <ul>
                    {t("policyDatos.sec8.items", { returnObjects: true }).map((item, i) => (
                        <li key={i}>{item}</li>
                    ))}
                </ul>
            </PolicySection>

            <PolicySection title={t("policyDatos.sec9.title")}>
                <p>{t("policyDatos.sec9.body")}</p>
            </PolicySection>

            <PolicySection title={t("policyDatos.sec10.title")}>
                <p>{t("policyDatos.sec10.body")}</p>
            </PolicySection>

            <PolicySection title={t("policyDatos.sec11.title")}>
                <p>{t("policyDatos.sec11.body")}</p>
            </PolicySection>

            <PolicySection title={t("policyDatos.sec12.title")}>
                <p>{t("policyDatos.sec12.body")}</p>
            </PolicySection>
        </PolicyPage>
    );
}

export default PoliticaDatos;
